import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ImmutableProptypes from 'react-immutable-proptypes'
import { Map } from 'immutable'
import classnames from 'classnames'
import { browserHistory } from 'react-router'

import ReactPasswordStrength from '_components/passwordStrengthInput'
import {
  login,
  LOGIN,
  signup,
  SIGNUP,
  getProfileInfo,
  GET_PROFILE_INFO,
} from '_modules/user/actions'
import { updateLastActivityAt } from '_modules/user/actions'
import { getMindfulBreaks } from '_modules/mindful-breaks/actions'
import { createFieldMissingErrorMessage, deepCopyJSON } from '_utils/helperFunction'

import styles from './styles.css'

const mapStateToProps = ({ user, loading, error }) => ({
  user,
  isLoadingLogin: !!loading.get(LOGIN.ACTION),
  isLoadingSignUp: !!loading.get(SIGNUP.ACTION),
  signUpErrors: error.get(SIGNUP.ACTION),
  loginErrors: error.get(LOGIN.ACTION),
  isLoadingProfileInfo: !!loading.get(GET_PROFILE_INFO.ACTION),
})

const mapDispatchToProps = {
  login,
  signup,
  getMindfulBreaks,
  getProfileInfo,
  updateLastActivityAt,
}

class SignUp extends PureComponent {
  static propTypes = {
    user: ImmutableProptypes.map,
    login: PropTypes.func.isRequired,
    isLoadingLogin: PropTypes.bool.isRequired,
    isLoadingSignUp: PropTypes.bool.isRequired,
    signup: PropTypes.func.isRequired,
    signUpErrors: PropTypes.string,
    getMindfulBreaks: PropTypes.func.isRequired,
    getProfileInfo: PropTypes.func.isRequired,
    updateLastActivityAt: PropTypes.func.isRequired,
  }

  static defaultProps = {
    user: new Map(),
    signUpErrors: null,
  }

  state = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    promotionalCode: '',
    passIsValid: false,
    error: null,
  }

  componentWillReceiveProps({
    isLoadingSignUp,
    signUpErrors,
    isLoadingLogin,
    loginErrors,
    user,
    isLoadingProfileInfo,
  }) {
    if (this.props.isLoadingSignUp && !isLoadingSignUp) {
      if (!signUpErrors) {
        const { email, password } = this.state
        const payload = {
          username: email,
          password,
        }
        this.props.login(payload)
      } else {
        this.props.displayError(signUpErrors)
      }
    } else if (!signUpErrors && this.props.isLoadingLogin && !isLoadingLogin) {
      if (user.get('token')) {
        this.props.getMindfulBreaks()
        this.props.getProfileInfo()
        this.props.updateLastActivityAt({ lastActivityAt: new Date() })
      } else {
        this.setState({
          error: 'Invalid credentials',
        })
      }
    } else if (
      !loginErrors &&
      !signUpErrors &&
      this.props.isLoadingProfileInfo &&
      !isLoadingProfileInfo
    ) {
      browserHistory.push('/')
    }
  }

  componentWillUnmount() {
    this.props.clearError()
  }

  onChange = event => {
    const { id, value } = event.target
    this.setState({
      [id]: value,
    })
  }

  onChangeTrim = event => {
    const { id, value } = event.target
    this.setState({
      [id]: value.trim(),
    })
  }

  onChangePassword = info => {
    const { score, isValid, password } = info
    this.setState({
      passIsValid: isValid,
      password,
    })
  }

  onSubmit = event => {
    event.preventDefault()
    const { firstName, lastName, email, password, passIsValid, promotionalCode } = this.state
    this.props.clearError()

    if (!firstName || !lastName || !email || !password) {
      this.props.displayError(
        createFieldMissingErrorMessage({ firstName, lastName, email, password })
      )
      return
    } else if (!passIsValid) {
      this.props.displayError('Password not strong enough')
    } else {
      const payload = {
        firstName,
        lastName,
        email,
        password,
        password2: password,
        promotionalCode,
      }

      this.props.signup(payload)
    }
  }

  termsClick = () => {
    window.open('/terms', '', 'width=800, height= 800')
  }

  formRef = null

  render() {
    const { firstName, lastName, email, promotionalCode, error } = this.state
    return (
      <form
        ref={form => (this.formRef = form)}
        onSubmit={this.onSubmit}
        className={classnames(styles.main, styles.Grid, styles['Grid--alignCenter'])}
      >
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'])}>
          <input
            type="text"
            id="firstName"
            placeholder="First Name"
            className={styles.input}
            value={firstName}
            onChange={this.onChange}
          />
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'])}>
          <input
            type="text"
            id="lastName"
            placeholder="Last Name"
            className={styles.input}
            value={lastName}
            onChange={this.onChange}
          />
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'])}>
          <input
            type="text"
            id="email"
            placeholder="Email"
            className={styles.input}
            value={email}
            onChange={this.onChangeTrim}
          />
        </div>
        <ReactPasswordStrength
          className={classnames(styles['Grid-cell'], styles['u-size1of1'])}
          id="password"
          minLength={8}
          minScore={2}
          changeCallback={this.onChangePassword}
        />
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'])}>
          <input
            type="text"
            id="promotionalCode"
            placeholder="Optional Promo Code"
            className={styles.input}
            value={promotionalCode}
            onChange={this.onChangeTrim}
          />
        </div>
        <div style={{ margin: 5 }} />
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles['terms-msg'])}>
          By creating an account, you agree to our{' '}
          <a className={classnames(styles['hilight'])} onClick={this.termsClick}>
            Terms & Conditions
          </a>
        </div>
        <div style={{ margin: 20 }} />
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'])}>
          <button type="submit" onClick={this.onSubmit} className={classnames(styles.button)}>
            SIGN UP
          </button>
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles['error-msg'])}>
          {error}
        </div>
      </form>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUp)



// WEBPACK FOOTER //
// ./src/views/signup/index.js